module.exports = __webpack_public_path__ + "static/media/书库.df31433e.png";